export interface IParseDealsBannerItem {
  /** Полное HTML-тело маркера */
  outerHtml: string;
  /** Id контейнера, в который монтируется DealsBanner */
  id: string;
}

export interface IParseDealsBanner {
  /** HTML-контент */
  html: string;
  /** Коллекция найденных маркеров баннера Сделки */
  items: IParseDealsBannerItem[];
}

/**
 * 1. Извлекает из HTML маркер `<div data-name="deal-experiment-banner"></div>`,
 *    который редактор вставляет в тексте статьи в нужном месте
 * 2. Заменяет маркер на пустой контейнер с уникальным id, в который потом
 *    монтируется DealsBanner
 */
export const parseDealsBanner = (html: string): IParseDealsBanner => {
  const pattern = /<div[^>]*?(?:data-name="deal-experiment-banner")[^>]*?>\s*<\/div>/gis;
  const items: IParseDealsBannerItem[] = [];
  let match;

  if (!html) {
    return {
      html: '',
      items,
    };
  }

  while ((match = pattern.exec(html))) {
    items.push({
      outerHtml: match[0],
      id: `deals-banner-${items.length + 1}`,
    });
  }

  return {
    html: items.reduce((acc, item) => acc.replace(item.outerHtml, `<div id="${item.id}"></div>`), html),
    items,
  };
};
